<mat-card>
  <app-card-header
    [title]="'Canal ' + (data?.nombre || data?.numero)"
    icono="videocam"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (data?.ids?.length) {
      <table class="dcc-tabla">
        <thead>
          <tr>
            <th>ID</th>
            <th>Ancho</th>
            <th>Alto</th>
          </tr>
        </thead>
        <tbody>
          @for (c of data?.ids; track c) {
            <tr>
              <td>
                @if (c.id) {
                  {{ c.id }}
                } @else {
                  <span class="no-info">Sin ID</span>
                }
              </td>
              <td>
                @if (c.width) {
                  {{ c.width }}
                } @else {
                  <span class="no-info">Sin dato</span>
                }
              </td>
              <td>
                @if (c.height) {
                  {{ c.height }}
                } @else {
                  <span class="no-info">Sin dato</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p class="dcc-vacio">
        <span class="no-info">Sin flujos configurados</span>
      </p>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
